import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthProvider';
import './SiteBanner.css';

const SiteBanner = () => {
  const { api } = useAuth();
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get('/api/getBanner')
      .then(res => {
        const data = res.data?.banner;
        if (data && data.active && data.message) {
          setBanner(data);
        }
      })
      .catch(() => {
        // No banner or endpoint not ready — stay hidden
      });
  }, [api]);

  if (!banner || dismissed) return null;

  return (
    <div className="site-banner" style={banner.bgColor ? { backgroundColor: banner.bgColor } : {}}>
      <span className="site-banner-message">{banner.message}</span>
      <button className="site-banner-close" onClick={() => setDismissed(true)} aria-label="Dismiss">
        &times;
      </button>
    </div>
  );
};

export default SiteBanner;
